import React, { PureComponent } from 'react';
import { Field, reduxForm } from 'redux-form';
import { withRouter, Link } from 'react-router-dom';
import Auth from '@aws-amplify/auth';
import { connect } from 'react-redux';
import ErrorAlert from '../../../alerts/components/BorderedAlertsWithIcons';
import { signin } from '../../../../redux/actions/userActions';
import { lastLoginAt } from '../../../../utils/mockData';

// import Tracker from '../../../../analytics/Tracker';
// const tracker = new Tracker();

class LogInForm extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      showPassword: false,
      errorMsg: null,
      loading: false,
      submitted: false
    }

    this.showPassword = this.showPassword.bind(this)
  }

  componentDidUpdate (prevProps, prevState) {
    return prevProps.user !== this.props.user
      ? this.props.user
        ? lastLoginAt
          ? this.props.history.push('/app/dashboard')
          : this.props.history.push('/onboarding/assessment/company-profile')
        : null
      : null
  }

  showPassword (e) {
    e.preventDefault()
    this.setState({
      showPassword: !this.state.showPassword
    })
  }

  async onSubmit (values) {
    try {
      this.setState({ loading: true, submitted: true })
      const user = await Auth.signIn(String(values.email).toLowerCase(), values.password)
      this.props.signin(user)
    } catch (e) {
      this.setState({ errorMsg: e.message, loading: false })
    }
  }

  renderField (field) {
    const { meta: { touched, error } } = field
    const className = `form-group ${touched && error ? 'red-text' : ''}`

    return (
      <div className={className}>
        <label>{field.label}</label>
        <input
          id={field.id}
          value={field.value}
          type={field.type}
          placeholder={field.placeholder}
          {...field.input} />
        <div className='text-help'>
          {touched ? error : ''}
        </div>
      </div>
    )
  }

  render () {
    const { handleSubmit } = this.props
    const params = new URLSearchParams(this.props.location.search)
    return (
      <div>
        {params.get('redirect') && !this.state.submitted ?
          <div className='error-container' >
            <ErrorAlert level='success' msg='Account has been updated. Login Below!' alertTag={'Success'} />
          </div> : null}
        {(this.props.passwordChanged && !this.state.submitted) ?
          <div className='error-container'>
            <ErrorAlert level='success' msg={this.props.msg} alertTag={'Success'} />
          </div> : null}
        <form className='form' onSubmit={handleSubmit(this.onSubmit.bind(this))
        }>
          { this.state.errorMsg === null ?
            <div className='error-container'>
              {/* <ErrorAlert level='danger' msg={this.state.errorMsg} alertTag={'Error'} /> */}
              </div>
          : this.state.errorMsg != 'Temporary password has expired and must be reset by an administrator.' ?
            <div className='error-container'>
              <ErrorAlert level='danger' msg={this.state.errorMsg} alertTag={'Error'} /></div>
            : this.state.errorMsg === 'Temporary password has expired and must be reset by an administrator.' ?
            <div className='error-container'>
              <ErrorAlert level='danger' msg={["Hi there, unfortunately your temporary password has expired. Please contact ", <a href="mailto: support@postured.io?subject=Temporary Password Expired">support@postured.io</a>," to have this resolved."]} alertTag={'Error'} /></div> 
            : null }

          <div className='form__form-group' >
            {/*<label className='form__form-group-label'>Username</label>*/}
            <div className='form__form-group-field'>
              {/*<div className='form__form-group-icon'>
                <AccountOutlineIcon />
              </div>*/}
              <Field
                id='emailField'
                name='email'
                component={this.renderField}
                type='text'
                placeholder='Email'
              />
            </div>
          </div>
          <div className='form__form-group'>
            {/*<label className='form__form-group-label'>Password</label>*/}
            <div className='form__form-group-field'>
              {/*<div className='form__form-group-icon'>
                <KeyVariantIcon />
              </div>*/}
              <Field
                id='passwordField'
                name='password'
                component={this.renderField}
                type={this.state.showPassword ? 'text' : 'password'}
                placeholder='Password'
              />
            </div>
          </div>
          <div className='form__form-group'>

            <div className='account__forgot-password'>
              <Link id='forget-password' to='/recover-password'>Forgot Password?</Link>
            </div>
          </div>
          {
            this.state.loading
              ? <button
                id='login'
                disabled={true}
                type='submit'
                className='loadingBtn btn btn-primary account__btn account__btn--small'>Sign In</button>
              : <button
                id='login'
                type='submit'
                className='btn btn-primary account__btn account__btn--small'>Sign In</button>
          }
        </form>
      </div>
    )
  }
}

function validate (values) {
  const errors = {}
  const re = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i //eslint-disable-line max-len
  const email = String(values.email || '').trim()

  if (!email) {
    errors.email = 'Email address is required'
  }

  if (!re.test(email)) {
    errors.email = 'Please enter a valid email'
  }

  if (!values.password) {
    errors.password = 'Password is required'
  }
  return errors
}

function mapStateToProps (state) {
  return {
    user: state.auth.user
  }
}

export default reduxForm({
  form: 'log_in_form', // a unique identifier for this form
  validate
})(withRouter(connect(mapStateToProps, { signin })(LogInForm)))



// WEBPACK FOOTER //
// ./src/components/account/log_in/components/LogInForm.js